<template>
  <div class="patents-page">
    <PageTitle
      title="Patents"
      subtitle="Below is a list of our patents."
      backgroundClass="-banner is-dark -banner-09"
    />
    <section class="section">
      <div class="container">
        <div class="box">
          <PatentsCopy />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import PatentsCopy from "@/components/copy/PatentsCopy.vue";

export default {
  name: "patentsPage",
  components: {
    PageTitle,
    PatentsCopy
  }
};
</script>

<style scoped lang="scss"></style>
